/*
 * @Author: zhangdingsong
 * @LastEditTime: 2023-12-05 15:23:48
 */
import { NewsItem } from "@root/common/interface/result";
import { getNewsList, getNewsDetail } from "@root/common/service";
import { PaginationProps, Table } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./_style.scss";
import { postLeaveAdvertisementTimeMap } from "@root/common/utils";
import { useSelector } from "react-redux";
import { RootState } from "@root/store/index";

export default function NewsList() {
  const [newsList, setNewsList] = useState<NewsItem[]>();
  const [total, setToal] = useState<number>();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { listId } = useParams();
  const { xy_navigation } = useSelector(
    (item: RootState) => item.advertisementData
  );
  const defaultPageSize = 5;

  const queryNewsList = async (
    listId: number,
    pageNum: number,
    pageSize: number
  ) => {
    setLoading(true);
    const { total, rows } = await getNewsList(listId, pageNum, pageSize);
    setNewsList(rows);
    setToal(total);
    setLoading(false);
  };
  useEffect(() => {
    queryNewsList(Number(listId), 1, defaultPageSize);
  }, [listId]);

  const dateFormat = (date: string) => {
    return date && date.split(" ")[0];
  };

  const columns = [
    {
      title: "标题",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "更新时间",
      dataIndex: "publishTime",
      key: "publishTime",
      width: "150px",
      render: (text: string) => <>[{dateFormat(text)}]</>,
    },
  ];

  const showTotal: PaginationProps["showTotal"] = (total) => `共 ${total} 条`;
  const paginationOptions = {
    total,
    defaultPageSize: defaultPageSize,
    showTotal: showTotal,
    showSizeChanger: true,
    showQuickJumper: true,
  };
  useEffect(() => {
    var startTime = new Date().valueOf() / 1000;
    return () => {
      postLeaveAdvertisementTimeMap(
        xy_navigation,
        startTime,
        xy_navigation.length,
        2
      );
    };
  }, []);
  return (
    <div className="news-list-conver">
      <Table
        columns={columns}
        dataSource={newsList}
        showHeader={false}
        loading={loading}
        pagination={paginationOptions}
        rowKey={(item) => item.id}
        onChange={(e) => {
          const { current, pageSize } = e;
          queryNewsList(
            Number(listId),
            current || 1,
            pageSize || defaultPageSize
          );
        }}
        onRow={(record) => {
          return {
            onClick: async () => {
              if (record.baseNewsType === "LINK") {
                const {
                  data: { context },
                } = await getNewsDetail(record.id);
                window.location.href = context;
                return;
              }
              var startTime = new Date().valueOf() / 1000;
              const { id, title } = record;
              let newsList = [
                {
                  id: id,
                  title: title,
                },
              ];
              postLeaveAdvertisementTimeMap(
                newsList,
                startTime,
                newsList.length,
                2,
                2
              );
              navigate(`/news/details/${id}`);
            },
          };
        }}
      ></Table>
    </div>
  );
}
